import { render } from "./ListExamPage.vue?vue&type=template&id=f259517a&scoped=true"
import script from "./ListExamPage.vue?vue&type=script&lang=js"
export * from "./ListExamPage.vue?vue&type=script&lang=js"

import "./ListExamPage.vue?vue&type=style&index=0&id=f259517a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f259517a"]])

export default __exports__